<template>
	<div class="detail_body">
		<div class="coll">
			<h2 class="title"><span>基本信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>工厂编码</th><td>{{sdata.factoryCode}}</td>
						<th>工厂描述</th><td>{{sdata.factoryDesc}}</td>
					</tr>
          <tr>
            <th>所属公司</th>
            <td colspan="3">{{sdata.companyCode}} - {{sdata.companyDesc}}</td>
          </tr>
					<!-- <tr>
						<th>供应商编号</th><td>{{sdata.supplierCode}}</td>
						<th>供应商描述</th><td>{{sdata.supplierDesc}}</td>
					</tr>
					<tr>
						<th>公司编码</th><td>{{sdata.companyCode}}</td>
						<th>公司描述</th><td>{{sdata.companyDesc}}</td>
					</tr>
					<tr>
						<th>客户号</th><td>{{sdata.customerCode}}</td>
						<th>客户描述</th><td>{{sdata.customerDesc}}</td>
					</tr> -->
				</table>
			</div>
		</div>

		<div class="coll">
			<h2 class="title"><span>联系信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>电子邮件</th><td>{{sdata.email}}</td>
						<th>联系电话</th><td>{{sdata.telephone}}</td>
					</tr>
					<tr>
						<th>地区</th><td>{{sdata.provinceDesc}} {{sdata.cityDesc}} {{sdata.countyDesc}}</td>
						<th>详细地址</th><td>{{sdata.streetOrAddress}}</td>
					</tr>
					<tr>
						<th>邮编</th><td>{{sdata.zipCode}}</td>
						<th>国家代码</th><td>{{sdata.contryKeyValue}}</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="coll">
			<h2 class="title"><span>其他信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>增值税登记号</th><td colspan="3">{{sdata.no}}</td>
						<th></th>
						<td></td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default{
  props:{
    sdata:Object
  },
	created(){

	},
	methods:{
	}
}
</script>
